import api from "@/services/api";

const url = "users";

const changeEmail = (email) => api.post(url.concat("/update-email"), email);

export default {
  changeEmail,
};
